import compareConstants    from './compare.constants';
import compareInitialState from './compare.state';

function compareReducer(state = compareInitialState, action) {
  switch (action.type) {
    case compareConstants.GET_COMPARE_LIST_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case compareConstants.GET_COMPARE_LIST_SUCCESS:
      state = {
        ...state,
        items:     action.items || compareInitialState.items,
        loading:   false,
      };
      break;

    case compareConstants.GET_COMPARE_LIST_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case compareConstants.SET_COMPARE_TRADE_OFFER:
      state = {
        ...state,
        tradeOffers: action.tradeOffers,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default compareReducer;